import { Box, Button, Divider, Grid, Stack, Typography } from '@mui/material'
import { controlButtonsStyle, modalTitleStyle } from '../../../../components/CampaignSetup/CampaignSetup.styles'
import { t } from 'i18next'
import React, { useState } from 'react'
import ConfirmationDialog from '../../../../components/ConfirmationDialog/ConfirmationDialog'
import useInterval from '../../../../utils/Interval/useInterval'
import { getTimeRemaining } from '../../../../utils/CalculateTimeRemaining/CalculateTimeRemaining'
import { useFeatureFlags } from '../../../../utils/FeatureFlags/useFeatureFlags'
import { Campaign } from '../../../../api/campaign/types'
import { runCampaign } from '../../../../api/campaign/runCampaign'
import { useNotification } from '../../../../components/Notification/NotificationContext'
import useFetchCampaign from '../../../../api/campaign/useFetchCampaign'
import { useAppSelector } from '../../../../store/utils/hooks'
import { selectCampaignPayload } from '../../../../store/slices/import/importSlice'
import { Trans } from 'react-i18next'

const WAITING_AFTER_RUN_CAMPAIGN = 20 * 60 * 1000

type CallProspectsProps = {
	children: React.ReactNode
	campaign: Campaign
	onClose: () => void
}

export default function CallProspects({ onClose, children, campaign }: CallProspectsProps) {
	const { FRONTEND_MAINTENANCE_MODE } = useFeatureFlags()
	const [enableRun, setEnableRun] = useState(false)
	const [remainingLabel, setRemainingLabel] = useState<any>(null)
	const [showConfirmationDialog, setShowCofirmatonDialog] = useState(false)
	// const { fetchingCampaign } = useFetchCampaign(String(campaign.campaign_id))

	const { addMessage } = useNotification()
	const campaignPayload = useAppSelector(selectCampaignPayload)

	useInterval(() => {
		if (campaign) {
			const { last_run_timestamp } = campaign
			if (!last_run_timestamp) {
				setEnableRun(true)
			} else {
				const remainingTime = getTimeRemaining(last_run_timestamp, WAITING_AFTER_RUN_CAMPAIGN)
				setRemainingLabel(remainingTime)
				setEnableRun(!remainingTime)
			}
		}
	}, 1000)

	const runCampaignHandler = async () => {
		try {
			onClose()
			addMessage({ success: 'Starting campaign...', timeout: 1000 })
			// if campaign.agent_id is not none, then we need to pass it to the runCampaign function
			console.log('campaign.agent_id', campaign.agent_id)
			await runCampaign(campaignPayload as any)
		} catch (error) {
			addMessage({ error: 'Error while running campaign', timeout: 1000 })
		}
	}

	return (
		<>
			<Box p="16px 0 0" sx={{ maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
				<Stack gap="32px" sx={{ overflowY: 'scroll', flex: 1 }}>
					<Grid container spacing={4} direction="row" sx={{ px: '16px' }}>
						<Grid item xs={12}>
							<Typography variant="h5" sx={modalTitleStyle}>
								{t('run_campaign.title')}
							</Typography>
						</Grid>
					</Grid>
					{children}
				</Stack>
				<Box p="16px 0 0">
					<Divider sx={{ mt: '32px' }} />
					<Box display="flex" flexDirection="row-reverse" mt="14px">
						<Button
							disabled={FRONTEND_MAINTENANCE_MODE || !enableRun}
							variant="contained"
							onClick={() => setShowCofirmatonDialog(true)}
							sx={controlButtonsStyle}
						>
							{!remainingLabel && 'Call Prospects'}
							{remainingLabel &&
								`Campaign Running… ${remainingLabel.minutes}:${remainingLabel.seconds} left`}
						</Button>
						<Button variant="outlined" onClick={() => onClose()} sx={controlButtonsStyle}>
							Cancel
						</Button>
					</Box>
				</Box>
			</Box>

			<ConfirmationDialog
				open={showConfirmationDialog}
				onClose={() => setShowCofirmatonDialog(false)}
				action={runCampaignHandler}
			>
				<Typography variant="h6" component="h2" marginBottom="24px" fontSize="14px">
					<Trans
						i18nKey="run_campaign.confirmation_modal_message"
						values={{ campaign_name: campaign?.campaign_name }}
						components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
					/>
				</Typography>
			</ConfirmationDialog>
		</>
	)
}
